import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Flex, Text } from '@stepstone-genesis/components';
import { ContentHeading } from '../../components/common/ContentHeading/index.js';
import { Trans, useTranslation } from '@stepstone-platform/i18n';
import { ArrowLeftIcon } from '@stepstone-genesis/icons';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { EnvelopeDocumentPictogram } from '../../components/common/EnvelopeDocumentPictogram/EnvelopeDocumentPictogram.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { emailSelector } from '../ResetPassword/resetPasswordSlice.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const TwoStepResetPasswordSuccess = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { value } = useAppSelector(emailSelector);
    const { trackBtnClick, trackModalComponentVisible } = useTrack('resetPassword');
    useEffect(() => {
        trackModalComponentVisible();
    }, []);
    const onBackToLoginClick = () => {
        trackBtnClick({ uniqueName: 'backToLogin' });
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_LOGIN));
    };
    return (_jsxs(Flex, { "data-testid": "two-step-reset-password-success", gap: 'spaceL', flxDirection: 'column', sx: { 'white-space': 'pre-line' }, flxItems: 'flex-start', children: [_jsx(EnvelopeDocumentPictogram, {}), _jsx(ContentHeading, { label: t('loginregistration.twoStepLoginRegistration.resetPassword.success.header') }), _jsx(Text, { textAlign: 'start', children: _jsx(Trans, { i18nKey: 'loginregistration.twoStepLoginRegistration.resetPassword.success.headerDescription', values: { email: value } }) }), _jsx(Button, { "data-testid": "reset-password-success-back-to-login-button", a11yLabel: "Back to login button", variant: "link", onClick: onBackToLoginClick, isLoading: false, iconBefore: _jsx(ArrowLeftIcon, {}), children: t('loginregistration.twoStepLoginRegistration.resetPassword.success.backLink') })] }));
};
//# sourceMappingURL=TwoStepResetPasswordSuccess.js.map